import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'
import threeReducer from '@/store/slices/three'

export const store = configureStore({
  reducer: {
    three: threeReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
